<dx-data-grid #productCategoryGrid
  [dataSource]="dataSource"
  [remoteOperations]="false"
  [allowColumnReordering]="false"
  [rowAlternationEnabled]="true"
  height="95vh"
  id="id"
>
<dxo-editing
    mode="batch"
    [allowAdding]="true"
    [allowUpdating]="true"
    [allowDeleting]="true"
  >
  </dxo-editing>
  <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxi-column dataField="product_category_code" dataType="string" caption="Code" width="15%">
    <dxi-validation-rule type="required" message="product category code is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="product_category_name" dataType="string" caption="Name">
    <dxi-validation-rule type="required" message="product category name is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="sort_order" dataType="string" caption="Sort Order" width="10%">
    <dxi-validation-rule type="required" message="product category sort order is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="id" dataType="integer" [visible]="false"></dxi-column>
</dx-data-grid>

